"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.device = exports.GlobalStyle = exports.useTheme = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@emotion/core");
const emotion_theming_1 = require("emotion-theming");
const images_1 = require("./images");
function useTheme() {
    return emotion_theming_1.useTheme();
}
exports.useTheme = useTheme;
const theme = {
    fontFamily: `Work Sans, sans-serif`,
    fontFamilyBold: `Work Sans, sans-serif`,
    // fontFamily: `'EuropaNuova-Regular', Lato, sans-serif`,
    // fontFamilyBold: `'EuropaNuova-Bold', Lato, sans-serif`,
    colors: {
        primary: '#229490',
        text: '#404357',
        white: '#FFFFFF',
        dark: '#404357',
        grey: '#F9F8F8',
        grey2a: '#ACB0B4',
        grey2: '#4F4F4F',
        grey3: '#828282',
        grey4: '#BDBDBD',
        grey5: '#E0E0E0',
        grey6: '#F2F2F2',
        lightgrey: '#ECE8E8',
        yellow: '#EFDCB7',
        secondary: '#EBD18A',
        darkyellow: '#CBAF88',
        red: '#EE8983',
        alertAmber: '#FF8E3C',
        alertRed: '#EB5757',
        alertRedBackground: '#EB57571F',
        purple: '#331261',
        alertYellow: '#FFDF2E',
        lightGreen: '#E9F4F4', // Light Green
    },
    logo: images_1.logo,
};
const GlobalStyle = () => (react_1.default.createElement(core_1.Global, { styles: core_1.css `
      body {
        font-family: ${theme.fontFamily};
      }

      .MuiTextField-root {
        width: 100% !important;
        max-width: 400px;
        min-width: 150px !important;
      }

      .MuiMenuItem-root {
        font-family: ${theme.fontFamily} !important;
        font-size: 16px !important;
        min-height: 48px !important;
        padding-left: 16px !important;
        padding-right: 16px !important;

        ${exports.device.tablet `
          font-size: 12px !important; 
          min-height: 32px !important;
          padding-left: 12px !important;
          padding-right: 12px !important;
        `}
      }

      .MuiListItemText-primary {
        font-family: ${theme.fontFamily} !important;
        font-size: 16px !important;

        ${exports.device.tablet `
          font-size: 12px !important; 
        `}
      }

      .MuiListItemText-secondary {
        font-family: ${theme.fontFamily} !important;
        font-size: 14px !important;

        ${exports.device.tablet `
          font-size: 10px !important; 
        `}
      }
    ` }));
exports.GlobalStyle = GlobalStyle;
const deviceSizes = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tabletS: '600px',
    tablet: '820px',
    laptop: '1024px',
    laptopL: '1440px',
    desktopS: '1600px',
    desktop: '2560px',
};
exports.device = Object.entries(deviceSizes).reduce((acc, [device, maxWidth]) => (Object.assign(Object.assign({}, acc), { [device]: (style) => `
        @media (max-width: ${maxWidth}) {
          ${style};
        }
      ` })), {});
exports.default = theme;
